import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import {
  EnvelopeFill,
  GeoAltFill,
  TelephoneFill,
  ClockFill,
} from "react-bootstrap-icons";
import YourProjectContact from "../LandingPage/YourProjectContect/YourProjectContect";

const ContactUs = () => {
  return (
    <Container fluid style={{ backgroundColor: "#f9f9f9", padding: "50px 0" }}>
      <div className="text-center mb-4">
        <Button
          variant="primary"
          style={{
            backgroundColor: "#007bff",
            border: "none",
            borderRadius: "20px",
            padding: "5px 20px",
            fontSize: "14px",
          }}
        >
          Contact us
        </Button>
        <h3 style={{ marginTop: "20px", color: "#007bff" }}>
          📧 Let’s Connect & Build <br /> Something Great Together
        </h3>
        <p
          style={{
            color: "#666",
            marginTop: "15px",
            maxWidth: "700px",
            margin: "0 auto",
          }}
        >
          Whether You’re Launching A New Product, Scaling Your Business, Or
          Revamping Your Digital Presence — Our Team Is Ready To Help With
          Tailored Solutions And Expert Support.
        </p>
      </div>

      <Row
        className="text-center mt-5"
        style={{ maxWidth: "900px", margin: "0 auto" }}
      >
        <Col
          md={6}
          style={{
            borderBottom: "1px solid #0C95CC",
            borderRight: "1px solid #0C95CC",
            padding: "30px",
          }}
        >
          <div
            style={{ fontSize: "30px", color: "#007bff", marginBottom: "10px" }}
          >
            <EnvelopeFill />
          </div>
          <h5>Email Us</h5>
          <p style={{ marginBottom: "5px" }}>We’re Always Happy To Help</p>
          <p>Info@idealcorp.In</p>
          <p>Info@idealcorp.In</p>
        </Col>

        <Col
          md={6}
          style={{ borderBottom: "1px solid #0C95CC", padding: "30px" }}
        >
          <div
            style={{ fontSize: "30px", color: "#007bff", marginBottom: "10px" }}
          >
            <GeoAltFill />
          </div>
          <h5>Visit Us</h5>
          <p style={{ marginBottom: "5px" }}>Our Address</p>
          <p>
            <strong>Ideal Corporate Services</strong>
            <br />
            No. 22, 1st Floor, Tech Park Main Road,
            <br />
            Chennai, Tamil Nadu - 600113
          </p>
        </Col>

        <Col
          md={6}
          style={{ borderRight: "1px solid #0C95CC", padding: "30px" }}
        >
          <div
            style={{ fontSize: "30px", color: "green", marginBottom: "10px" }}
          >
            <TelephoneFill />
          </div>
          <h5>Call Us</h5>
          <p style={{ marginBottom: "5px" }}>Direct Support Line</p>
          <p>+91 99943 11042</p>
          <p>+91 73977 54321</p>
        </Col>

        <Col md={6} style={{ padding: "30px" }}>
          <div
            style={{ fontSize: "30px", color: "#7e57c2", marginBottom: "10px" }}
          >
            <ClockFill />
          </div>
          <h5>Working Hours</h5>
          <p style={{ marginBottom: "5px" }}>Mon – Sat, 9:30 AM To 6:00 PM</p>
          <p style={{ fontStyle: "italic", color: "#666" }}>
            We’re Flexible To Your Schedule — Feel Free To Request A Time That
            Suits You.
          </p>
        </Col>
      </Row>

      <div style={{ marginTop: "40px", textAlign: "center" }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5563.075505745021!2d80.1668745080826!3d13.034897043543541!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a526177a025863d%3A0xba15ee44471b8fbd!2sIdeal%20Corporate%20Services!5e0!3m2!1sen!2sin!4v1751022040154!5m2!1sen!2sin"
          width="90%"
          height="300"
          style={{ border: "0", borderRadius: "10px" }}
          allowFullScreen=""
          loading="lazy"
          title="Google Map"
        ></iframe>
      </div>
        <YourProjectContact />
    </Container>
  );
};

export default ContactUs;
